<div class=" card card-user">
  <div class=" card-body">
    <p class=" card-text"></p>


    <div class=" author">
      <div class=" block block-one"></div>
      <div class=" block block-two"></div>
      <div class=" block block-three"></div>
      <div class=" block block-four"></div>
      <div class="d-flex justify-content-end backButton" *ngIf="back"
           [ngStyle]="{'right': this.apiService.currentDirection == 'ltr' ? '55px' : null}">
        <a [routerLink]="[back]">
          {{'Button.Back'|translate}}
        </a>
      </div>


      <!-- idCard: {number: "2282142519", image: "9C466229EBE96BCEF117CE6BF8D5529D", status: 2}
      isActive: true
      licenses: []
      profilePic: "A7F3E1559ACCFF7057CCA0C8F8F387CD" -->

      <a href="javascript:void(0)" class="position-relative">
        <img alt="..." class=" avatar"
             [src]="user.techImage ? user.techImage: '../../../../assets/img/default-avatar.png'"
             [title]="user.fullName"/><br/>
      </a>


      <a href="javascript:void(0)">
        <h5 class="mt-3">{{user.fullName}}</h5>

        <p class="ltr py-1">+{{user.phonenumber}}</p>
        <p class="py-1">{{user.country + ', ' + user.province + ', ' +
        user.city}}</p>
      </a>
      <div *ngIf="user.technicnianInfo">

        <div class="row container py-2 px-5" *ngIf="user.technicnianInfo.skills.length>0">
          <p>{{'Users.Skills'|translate}}:</p>


          <div class="mx-3" *ngFor="let item of user.technicnianInfo.skills">- &nbsp;{{item.name}}: &nbsp;

            <span class="badge badge-info" *ngFor="let tag of item.tags">{{tag.title}}</span>
            <span *ngIf="item.tags.length===0">-</span>
            <br/>
          </div>

        </div>


        <div class="row container py-2 px-5"
             *ngIf="user.technicnianInfo.confirmations.length>0">
          <div class="mt-2">
            {{'Sidebar.Corroborations'|translate}} :
          </div>

          <img class="mx-2" *ngFor="let item of user.technicnianInfo.confirmations"
               [title]="item.name" [src]="item.iconImage" style="width: 40px;height: 40px;border-radius: 50%;"/>

        </div>
      </div>
      <div class="row container py-2 px-5">
        <div class="text-center box pointer" (click)="this.internalService.imageView(user.idCard.idCardImage)">
          <img class="mx-2 logoInTable"
               [title]="user.idCard.number" [src]="user.idCard.idCardImage"/>
          <p class="pt-2">{{'Users.IdCardNumber'|translate}}: {{user.idCard.number}}</p>
          <p> {{'Users.NationalCardStatus'|translate}}&nbsp;
            : {{user.idCard.status === 0 ? ('Users.NationalCardNotRequested'|translate) : user.idCard.status === 1 ? ('Users.NationalCardRequested'|translate) : user.idCard.status === 3 ? ('Users.RequestRejected'|translate) : user.idCard.status === 2 ? ('Users.RequestAccepted'|translate) : null}}</p>

        </div>
        <div class="text-center box  pointer"
             (click)="this.internalService.imageView(user.technicnianInfo.certificateInfo.base64)">
          <img class="mx-2 logoInTable"
               [title]=""
               [src]="user.technicnianInfo.certificateInfo.base64? user.technicnianInfo.certificateInfo.base64:'../../../../assets/img/default.png'"/>
          <p class="pt-2"></p>
          <p> {{'Users.License'|translate}}&nbsp;
            : {{user.technicnianInfo.certificateInfo.status === 0 ? ('Users.NationalCardNotRequested'|translate) : user.technicnianInfo.certificateInfo.status === 1 ? ('Users.NationalCardRequested'|translate) : user.technicnianInfo.certificateInfo.status === 3 ? ('Users.RequestRejected'|translate) : user.technicnianInfo.certificateInfo.status === 2 ? ('Users.RequestAccepted'|translate) : null}}</p>

        </div>

      </div>

    </div>
    <div class=" card-footer d-flex justify-content-end">


    </div>
  </div>
</div>


<ng-template let-c="close" let-d="dismiss" #modal>
  <div class="modal-header">
    <!--    <h4 class="addEditDel-title"-->
    <!--        [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr', 'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">-->
    <!--      {{'Users.Verification'|translate}}</h4>-->
  </div>
  <!------------------  image ---------------------------------------------->
<!--  <div class="frame" *ngIf="this.modalContent==='img'">-->
<!--    <div class=" col-md-12" style="height: 70vh; overflow: auto;">-->
<!--      <a href="javascript:void(0)">-->
<!--        <img [src]="image" style=" width: 100%; height: auto;"> <br/>-->
<!--      </a>-->
<!--    </div>-->
<!--    <div class="col-12 d-flex justify-content-end">-->

<!--      <button type="button" class="btn mx-1 mt-3"-->
<!--              (click)="d('Cross click')">{{'Button.Close'|translate}}-->
<!--      </button>-->


<!--    </div>-->
<!--  </div>-->
  <!------------------  delete ---------------------------------------------->
  <div class="frame" *ngIf="this.modalContent==='del'">
    <div class=" col-md-12">
      <div class="m-3">
        <p>{{'Message.AreYouSureToDelete?'| translate}}</p>
      </div>
    </div>
    <div class="col-12 d-flex justify-content-end">

      <button type="button" class="btn mx-1 mt-3"
              (click)="d('Cross click')">{{'Button.Close'|translate}}
      </button>
      <button type="button" class="btn mx-1 mt-3"
              (click)="removeTechnicianVerification();">{{'Button.Delete'|translate}}
      </button>

    </div>
  </div>
</ng-template>
